var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShapeDesktop3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 328 288",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M250.178 70.4091C243.772 -27.6243 199.7 -4.15244 136.602 31.5812C106.651 51.6167 70.3088 76.9769 11.258 198.401C-62.5555 350.182 281.931 280.198 318.339 198.22C358.184 108.504 256.389 165.449 250.178 70.4091Z",
  fill: "current"
})));
export default SvgShapeDesktop3;